<router-outlet></router-outlet>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/app.component.ts.AppComponent.html